/* MediVerified basket helpers: pack upgrades, quick add, and keeping the basket page in step with the drawer.
   Loaded by sections/main-cart-items.liquid and sections/mv-cart-extras.liquid (guarded so it only runs once). */
(function () {
  if (window.MVCart) return;

  var r = window.routes || {};
  var CART_URL = r.cart_url || '/cart';
  var ADD_URL = (r.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (r.cart_change_url || '/cart/change') + '.js';
  var internal = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return selector ? doc.querySelector(selector) : doc.body;
  }

  function showError(err) {
    var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    var msg = (err && (err.description || err.message)) || (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
    if (box) box.textContent = typeof msg === 'string' ? msg : (window.cartStrings && window.cartStrings.error) || '';
  }

  function clearError() {
    var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = '';
  }

  /* Re-render the basket page (items + footer), the drawer, the header bubble and any section marked
     data-mv-rerender, then tell mv-reward.js the cart changed. */
  function refreshAll(opts) {
    opts = opts || {};
    internal = true;
    var jobs = [];
    var pageItems = document.querySelector('cart-items');
    var drawerItems = document.querySelector('cart-drawer-items');

    jobs.push(
      fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var empty = !cart.item_count;
          if (pageItems) pageItems.classList.toggle('is-empty', empty);
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', empty);
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', empty);
        })
        .catch(function () {})
    );

    if (pageItems && typeof pageItems.onCartUpdate === 'function') jobs.push(pageItems.onCartUpdate());
    if (opts.drawer !== false && drawerItems && typeof drawerItems.onCartUpdate === 'function') jobs.push(drawerItems.onCartUpdate());

    var ids = ['cart-icon-bubble'];
    var footerEl = document.getElementById('main-cart-footer');
    if (footerEl && footerEl.dataset.id) ids.push(footerEl.dataset.id);
    var extras = [].slice.call(document.querySelectorAll('[data-mv-rerender]'));
    extras.forEach(function (el) { if (el.dataset.mvRerender) ids.push(el.dataset.mvRerender); });

    jobs.push(
      fetch(CART_URL + '?sections=' + ids.join(','))
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var bubble = document.getElementById('cart-icon-bubble');
          var fresh = sections['cart-icon-bubble'] ? parseSection(sections['cart-icon-bubble'], '.shopify-section') : null;
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;

          if (footerEl && sections[footerEl.dataset.id]) {
            var target = footerEl.querySelector('.js-contents');
            var source = parseSection(sections[footerEl.dataset.id], '.js-contents');
            if (target && source) target.innerHTML = source.innerHTML;
          }

          extras.forEach(function (el) {
            var id = el.dataset.mvRerender;
            var wrapper = document.getElementById('shopify-section-' + id);
            var src = sections[id] ? parseSection(sections[id], '.shopify-section') : null;
            if (wrapper && src) wrapper.innerHTML = src.innerHTML;
          });
        })
        .catch(function () {})
    );

    return Promise.all(jobs)
      .catch(function () {})
      .then(function () {
        internal = false;
        document.dispatchEvent(new CustomEvent('mv:cart-changed'));
      });
  }

  /* Swap a basket line for a bigger pack of the same product. */
  function upgrade(btn) {
    var newId = Number(btn.dataset.mvUpgrade);
    var key = btn.dataset.mvKey;
    var qty = Number(btn.dataset.mvQty || 1);
    if (!newId || !key) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Switching…';
    clearError();
    post(ADD_URL, { items: [{ id: newId, quantity: qty }] })
      .then(function () { return post(CHANGE_URL, { id: key, quantity: 0 }); })
      .then(function () { return refreshAll(); })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        showError(err);
      });
  }

  /* Add one variant from the quick-add grid. */
  function quickAdd(btn) {
    var id = Number(btn.dataset.mvQuickAdd);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';
    clearError();
    post(ADD_URL, { items: [{ id: id, quantity: 1 }] })
      .then(function () {
        btn.textContent = 'Added';
        var card = btn.closest('.mv-quick-add__item');
        if (card) card.classList.add('mv-quick-add__item--added');
        return refreshAll().then(function () {
          /* Away from the basket page, show the drawer so the customer sees what they just added. */
          var drawer = document.querySelector('cart-drawer');
          if (!document.querySelector('cart-items') && drawer && typeof drawer.open === 'function') {
            try { drawer.open(btn); } catch (e) {}
          }
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        showError(err);
      });
  }

  document.addEventListener('click', function (event) {
    var up = event.target.closest('[data-mv-upgrade]');
    if (up) { event.preventDefault(); if (!up.disabled) upgrade(up); return; }
    var qa = event.target.closest('[data-mv-quick-add]');
    if (qa) { event.preventDefault(); if (!qa.disabled) quickAdd(qa); }
  });

  /* On the basket page, Dawn and mv-reward.js re-render the drawer but not the page when the cart changes
     in the background (for example when the free gift is added). Watch the drawer and bring the page along. */
  function watchDrawer() {
    var page = document.querySelector('cart-items');
    var drawer = document.querySelector('cart-drawer');
    if (!page || !drawer || !window.MutationObserver) return;
    var timer;
    new MutationObserver(function (mutations) {
      if (internal) return;
      var relevant = mutations.some(function (m) {
        return [].slice.call(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (n.matches('cart-drawer-items, .drawer__inner, .cart-drawer__footer') || (n.querySelector && n.querySelector('cart-drawer-items')));
        });
      });
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(function () { refreshAll({ drawer: false }); }, 250);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();

  window.MVCart = { refreshAll: refreshAll, post: post, showError: showError };
})();
